import configuracion from './configuracion'
import informes from './informes'
import mantenimiento from './mantenimiento'
import transacciones from './transacciones'
import { permissionTree as permisosProduccionPg, RESOURCE_PRODUCCION_PG } from '@/auth/permissions/modules/produccionPg'
import { defineMenu } from '@/utils/menu'

export default defineMenu([
    {
        title: 'produccion_pg.menu_title',
        fontIcon: 'truck-loading',
        resource: RESOURCE_PRODUCCION_PG,
        action: permisosProduccionPg._root,
        children: [
            {
                title: 'global.menu.configuracion',
                icon: 'SettingsIcon',
                resource: RESOURCE_PRODUCCION_PG,
                action: permisosProduccionPg.configuracion._perm,
                children: configuracion,
            },
            {
                title: 'global.menu.mantenimiento',
                icon: 'SettingsIcon',
                resource: RESOURCE_PRODUCCION_PG,
                action: permisosProduccionPg.mantenimiento._perm,
                children: mantenimiento,
            },
            {
                title: 'global.menu.transacciones',
                fontIcon: 'exchange-alt',
                resource: RESOURCE_PRODUCCION_PG,
                action: permisosProduccionPg.transacciones._perm,
                children: transacciones,
            },
            {
                title: 'global.menu.informes',
                fontIcon: 'file-prescription',
                resource: RESOURCE_PRODUCCION_PG,
                action: permisosProduccionPg.informes._perm,
                children: informes,
            },
        ],
    },
])
